import {
  SurchargeDisputeDataSchema,
  SurchargeDisputeUpdateSchema,
} from "@redotech/redo-billing-common/surcharge-dispute";
import * as z from "zod";

export const updateSurchargeDispute = {
  name: "updateSurchargeDispute" as const,
  input: SurchargeDisputeUpdateSchema,
  output: z.object({ dispute: SurchargeDisputeDataSchema }),
};
